export const manejoErrores = {
  data() {
    return {
      errores: [],
      modificado: []
    };
  },

  methods: {
    guardarError: function(campo, mensaje) {
      this.errores.push({ campo, mensaje });
    },

    limpiarError: function(campo) {
      let indice = this.errores.findIndex(e => e.campo == campo);
      if (indice != -1) {
        this.errores.splice(indice, 1);
      }
    },

    mensajeError: function(campo) {
      let error = this.errores.find(e => e.campo == campo);
      return error ? error.mensaje : "";
    },

    tieneError: function(campo) {
      if (this.modificado.indexOf(campo) != -1) {
        return this.errores.find(e => e.campo == campo) ? false : null;
      }
      return null;
    }
  }
};



// WEBPACK FOOTER //
// ./src/assets/js/manejoErrores.js